import React from 'react';
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { TableCell, TableRow } from "@/components/ui/table";
import { Quote } from "@/types/quote";
import { Copy, Edit, MoreHorizontal, Trash2 } from "lucide-react";

interface QuoteListItemProps {
  quote: Quote;
  isSelected: boolean;
  onSelect: (checked: boolean) => void;
  onEdit: () => void;
  onDelete: () => void;
  isDuplicate: boolean;
}

export function QuoteListItem({
  quote,
  isSelected,
  onSelect,
  onEdit,
  onDelete,
  isDuplicate
}: QuoteListItemProps) {
  return (
    <TableRow className={isDuplicate ? "bg-yellow-50" : ""}>
      <TableCell className="w-12">
        <Checkbox
          checked={isSelected}
          onCheckedChange={onSelect}
        />
      </TableCell>
      <TableCell>{quote.content}</TableCell>
      <TableCell>{quote.author || '-'}</TableCell>
      <TableCell>
        {quote.categories?.map(cat => cat.name).join(', ') || '-'}
      </TableCell>
      <TableCell>
        <div className="flex gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={onEdit}
          >
            <Edit className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={onDelete}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
}
